import { validateSuggestion } from '../../methods/validate-suggestion'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Öneri verilerini doğrular
 * @param {Object} suggestionData - Doğrulanacak öneri verileri
 * @returns {Object} Doğrulama sonucu: {isValid, errors, formattedErrorMessage}
 */
export const validateData = (suggestionData) => {
  // Öneri verilerini doğrula
  const { isValid, errors } = validateSuggestion(suggestionData)

  // Hata mesajını formatla
  let formattedErrorMessage = null
  if (!isValid) {
    formattedErrorMessage = `Validasyon hatası: ${Object.values(errors).join(', ')}`
  }

  return { isValid, errors, formattedErrorMessage }
}